import type {
  BriqpaySession,
  KlarnaOrder,
  NexiRetrievePaymentResponse,
  PaymentProviderName,
  QliroOrder,
  SveaOrder
} from 'ecosystem'
import { briqpayApi, klarnaApiCall, qliroApi, sveaApi } from 'api'
import { nexiApi } from 'api/utils/nexi'
import { type GetOrderProviderAdapter } from './types'

const klarnaAdapter: GetOrderProviderAdapter<KlarnaOrder> = {
  retrieve: (orderId) => klarnaApiCall<KlarnaOrder, undefined>('get', { orderId }),
  respond: (klarnaResponse) => ({ klarnaResponse })
}

const nexiAdapter: GetOrderProviderAdapter<NexiRetrievePaymentResponse> = {
  retrieve: (orderId) => nexiApi.checkout.retrievePayment(orderId),
  respond: (nexiResponse) => ({ nexiResponse })
}

const sveaAdapter: GetOrderProviderAdapter<SveaOrder> = {
  retrieve: (orderId) => sveaApi.checkout.retrieveOrder(orderId),
  respond: (sveaResponse) => ({ sveaResponse })
}

const qliroAdapter: GetOrderProviderAdapter<QliroOrder> = {
  retrieve: (orderId) => qliroApi.checkout.retrieveOrder(orderId),
  respond: (qliroResponse) => ({ qliroResponse })
}

const briqpayAdapter: GetOrderProviderAdapter<BriqpaySession> = {
  retrieve: (orderId) => briqpayApi.checkout.readSession(orderId),
  respond: (briqpayResponse) => ({ briqpayResponse })
}

/**
 * LEDYER is deliberately absent — it has no implementation yet, and the entry
 * point turns the missing key into the same "not implemented" error the pages
 * version threw.
 */
export const GET_ORDER_ADAPTERS: Partial<
  Record<PaymentProviderName, GetOrderProviderAdapter<any>>
> = {
  KLARNA: klarnaAdapter,
  NEXI: nexiAdapter,
  SVEA: sveaAdapter,
  QLIRO: qliroAdapter,
  BRIQPAY: briqpayAdapter
}
